import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Dashboard = () => {
  const [submissions, setSubmissions] = useState([]);
  const navigate = useNavigate();

  // Fetch submissions
  useEffect(() => {
    const fetchSubmissions = async () => {
      try {
        const response = await axios.get("/api/admin/submissions", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
          console.log("✅ API Response:", response.data);
        setSubmissions(response.data);
      } catch (err) {
        console.error("Error fetching submissions:", err);
        toast.error("Failed to load submissions");
      }
    };

    fetchSubmissions();
  }, []);

  // Logout handler
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    navigate("/schoollogin");
  };

  // Excel download (already working)
  const downloadExcel = async () => {
    try {
      const response = await axios.get("/api/admin/submissions/download/xls", {
        responseType: "blob",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "all-submissions.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      toast.success("Excel downloaded successfully!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to download Excel");
    }
  };

  // Download single PDF per submission
  const downloadPDF = async (id) => {
    try {
      const response = await axios.get(`/api/admin/submissions/${id}/download/pdf`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `submission-${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      toast.success("PDF downloaded successfully!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to download PDF");
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <ToastContainer position="top-center" />
      <h1>📋 Dashboard</h1>
      <div style={{ marginBottom: "20px" }}>
        <button
          onClick={downloadExcel}
          style={{ margin: "10px", padding: "10px 20px", cursor: "pointer" }}
        >
          Download Excel
        </button>
        <button
          onClick={handleLogout}
          style={{
            margin: "10px",
            padding: "10px 20px",
            backgroundColor: "tomato",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div>

      <table
        style={{
          margin: "0 auto",
          width: "90%",
          borderCollapse: "collapse",
          boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
        }}
      >
        <thead style={{ backgroundColor: "#f0f0f0" }}>
          <tr>
            <th style={thStyle}>#</th>
            <th style={thStyle}>Submission Date</th>
            <th style={thStyle}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {submissions.length > 0 ? (
            submissions.map((sub, index) => (
              <tr key={sub._id}>
                <td style={tdStyle}>{index + 1}</td>
                <td style={tdStyle}>
                  {new Date(sub.submissionDate).toLocaleDateString()}
                </td>
                <td style={tdStyle}>
                  <button
                    onClick={() => downloadPDF(sub._id)}
                    style={{
                      backgroundColor: "#4caf50",
                      color: "white",
                      border: "none",
                      padding: "6px 12px",
                      cursor: "pointer",
                      borderRadius: "4px",
                    }}
                  >
                    Download PDF
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ padding: "15px" }}>
                No submissions found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

// Styles for table cells
const thStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "center",
};

export default Dashboard;
